import { useEffect, useRef, type RefObject } from "react";
type Opts = {
  behavior?: ScrollBehavior;
  elementRef?: RefObject<HTMLElement | null>;
};
export default function useScrollToTopOnChange(deps: unknown[], {
  behavior = "smooth",
  elementRef
}: Opts = {}, isActive?: boolean) {
  //useWhatChanged(deps);

  const first = useRef(true);
  // A monotonically increasing "version" for each effect run.
  // Lets us ignore the Strict Mode duplicate run (and any stale async work).
  const version = useRef(0);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return; // ikke scroll på første render
    }
    if (!isActive) {
      return;
    }
    // This run's id
    //const runId = ++version.current;
    const target = elementRef?.current ?? window;

    // Ensure post-paint (scrolling feels better after layout settles)
    const raf = requestAnimationFrame(() => {
      //if (version.current !== runId) return;
      console.debug("VERSION", version.current);
      // DOM vs window scrolling
      if ("scrollIntoView" in target) {
        // target is an Element
        (target as Element).scrollIntoView({
          behavior
        });
      } else {
        // target is window
        window.scrollTo({
          top: 0,
          behavior
        });
      }
    });
    return () => {
      //version.current++;
      cancelAnimationFrame(raf);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}